// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Extauth2ChangePasswordStatus } from './extauth2ChangePasswordStatus.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class AuthenticationAuthenticationChangePasswordDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': Extauth2ChangePasswordStatus;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof AuthenticationAuthenticationChangePasswordDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Extauth2ChangePasswordStatus"
        },
    ];

    static getAttributeTypeMap() {
        return AuthenticationAuthenticationChangePasswordDefaultResponse.attributeTypeMap;
    }
}
